<template>
    <div v-if="!hide" class="form-network form-network-pinterest">
       <details open>
           <summary>Selection du tableau <i class="fa-solid fa-caret-down"></i></summary>
           <div class="content-detail">
            <div class="selects">
                <SelectComponent :valueSelect="inputModel.pageIdSelectBoardSelect" :changeValueSelect="(v)=>inputModel.pageIdSelectBoardSelect = v" :data="pagePinterestSelectedForSelect"  :positionAuto="false" :positionX="'left'"></SelectComponent>
                <SelectComponent 
                    :valueSelect="boardsPages[inputModel.pageIdSelectBoardSelect] && boardsPages[inputModel.pageIdSelectBoardSelect].length ?  
                        formDataPinterest.boardSelectedByPage[inputModel.pageIdSelectBoardSelect] ? 
                            formDataPinterest.boardSelectedByPage[inputModel.pageIdSelectBoardSelect] 
                            : 'unselected' 
                        : 'none'" 
                    :changeValueSelect="selectBoard" 
                    :data="boardsPages[inputModel.pageIdSelectBoardSelect] && boardsPages[inputModel.pageIdSelectBoardSelect].length ? {...(!inputModel.boardSelectedPerPage[inputModel.pageIdSelectBoardSelect] ? {unselected : 'Aucun sélectionné'} : {}) ,...Object.fromEntries(boardsPages[inputModel.pageIdSelectBoardSelect].map(board => [board.id, board.name]))} : { 'none' : 'Aucun tableau'}"  
                    :positionAuto="false" :positionX="'left'"
                />
            </div>
            
           </div>      
       </details>
       <details open>
           <summary>Création de tableau <i class="fa-solid fa-caret-down"></i></summary>
           <div class="content-detail">
            <div class="selects">
                <SelectComponent :valueSelect="inputModel.pageIdSelectBoardCreate" :changeValueSelect="(v)=>inputModel.pageIdSelectBoardCreate = v" :data="{all: 'Pour l\'ensemble des comptes',...pagePinterestSelectedForSelect}"   :positionAuto="false" :positionX="'left'"></SelectComponent>
                <div class="type-input">
                    <input placeholder="Nom du tableau" v-model="inputModel.valueNewBoard" @keyup.enter="()=> createBoard()">
                </div>
            </div>
            
           </div>      
       </details>
        <details open>
            <summary>Selection du lien<i class="fa-solid fa-caret-down"></i></summary>
            <div class="content-detail form-link">
                <div class="list-thubmmail">
                    <div class="thubmmail" v-for="(url) in this.formData.urlsTextContentHistory" @click="()=>selectUrl(url)" :key="url">
                        <Checkbox :id="url" :prefixId="'thubmmail-'" 
                            :isChecked="(formDataPinterest.snippet.link == url)" 
                            :isDisable="(formDataPinterest.snippet.link == url)"
                            :add="selectUrl" :remove="()=>{}">
                        </Checkbox>
                        <SnippetNetwork 
                            :link="url"
                        />
                    
                    </div>
                </div>      
            </div>
        </details>
   </div>
</template>

<script>
    import { EventBus } from '@/event-bus';
    import store from './../../../../store/index.js';
    import ComponentSwitch from '../../utils/switch.vue'
    import SelectComponent from '../../utils/select.vue'
    import Checkbox from '../../utils/checkbox.vue'
    import SnippetNetwork from './../SnippetNetwork.vue'
    import minxinBot from '../../../mixins/Bots.vue'
    import minxinPost from '../../../mixins/Posts.vue'
    import minxinNotif from '../../../mixins/Notif.vue'
    export default {

        components: {
            ComponentSwitch,
            SnippetNetwork,
            SelectComponent,
            Checkbox
        },
        mixins: [minxinBot, minxinPost, minxinNotif],

        props: {
            hide : {
                type: Boolean,
                default: false
            },
            formData: {
                type: Object,
                default: () => ({})
            },

            formDataPinterest: {
                type: Object,
                default: () => ({})
            },
        },

        data() {
            return {
                inputModel:{
                    pageIdSelectBoardSelect : null,
                    pageIdSelectBoardCreate : 'all',
                    boardSelectedPerPage : {},
                    valueNewBoard: ''
                },

                boardsPages: {
                    //idPage: {}
                },

                pagesPinterestSelected : [],
                lastModeSelected : undefined
            }
        },

        
        mounted() {
            if (this.formData.formDataNetwork.pinterest) this.formDataPinterest = this.formData.formDataNetwork.pinterest
            
        },

        created () {
            this.pagesPinterestSelected  = this.pagesSelected.filter(p => p.network == 'pinterest')
            this.detectPageIdSelectBoardSelect()
            this.detectPageIdSelectBoardCreate()

            this.pagesPinterestSelected.forEach(async (page) => {
                await this.getBoards(page.id, page)
            });
        },

        methods: {
            addMode(mode) {
                this.lastModeSelected = mode
                EventBus.$emit("postCreatorAddMode", mode);
            },
            changeVisibilityPost(state) {
                this.formDataPinterest.visibility = state
                this.$emit('setFormDataNetwork', 'pinterest', this.formDataPinterest)
            },

            detectPageIdSelectBoardSelect() {
                if (!this.inputModel.pageIdSelectBoardSelect || !this.pagesSelected.find(p => p.id == this.inputModel.pageIdSelectBoardSelect)) {
                    try {
                        this.inputModel.pageIdSelectBoardSelect = this.pagesPinterestSelected[0].id
                    } catch (error) {
                        this.inputModel.pageIdSelectBoardSelect = null
                    }
                }
            },

            detectPageIdSelectBoardCreate() {
                if (this.inputModel.pageIdSelectBoardCreate !== 'all' && (!this.inputModel.pageIdSelectBoardCreate || !this.pagesSelected.find(p => p.id == this.inputModel.pageIdSelectBoardCreate))) {
                    this.inputModel.pageIdSelectBoardCreate = 'all'
                }
            },

            selectUrl(url) {
                if (!this.formDataPinterest.snippet) this.formDataPinterest.snippet = {}
                this.formDataPinterest.snippet.link =  this.formDataPinterest.snippet.link == url ? '' : url
                this.$emit('setFormDataNetwork', 'pinterest', this.formDataPinterest)
            },


            verifUrlSelected() {
                if (this.formData.urlsTextContentHistory.size) {
                    let linkSelect = this.formDataPinterest && this.formDataPinterest.snippet && this.formDataPinterest.snippet.link ? this.formDataThreads.snippet.link : null
                    if ((linkSelect && !this.formData.urlsTextContentHistory.has(linkSelect))) {
                        this.selectUrl('')
                    }
                }else{
                    this.selectUrl('')
                }
             
            },

            async getBoards(pageId, page = null) {
                if (this.boardsPages[pageId]) return this.boardsPages[pageId]
                
                if (!page) page = this.pagesPinterestSelected.find(page => (page.id == pageId))
                
                if (page) {
                    this.boards = await this.getBoardPinterest(page)
                    if (this.boards.body && this.boards.body.board && this.boards.body.board.items) {
                        this.$set(this.boardsPages , pageId, this.boards.body.board.items)
                        return this.boards.body
                    }else {
                        this.$set(this.boardsPages , pageId, [])
                    }
                }
               
                return []
            },

            async createBoard() {
                if (!this.inputModel.valueNewBoard) return
                let pages = []
                if (this.inputModel.pageIdSelectBoardCreate == 'all') {
                    pages = this.pagesSelected
                }else{
                    pages = [this.inputModel.pageIdSelectBoardCreate]
                }

                let echecPageName = []
                const promises = pages.map(async page => {
                    
                    try {
                        const res = await this.createBoardPinterest(page, this.inputModel.valueNewBoard);

                        if (res.body.board.code) {
                            console.log('error',page.name)
                            throw new Error('Board creation failed');
                        } else {
                            res.body.board
                            this.$set(this.boardsPages , page.id, [res.body.board,...this.boardsPages[page.id]])
                            this.$set(this.inputModel.boardSelectedPerPage, page.id, res.body.board.id)
                        }
                    } catch (error) {
                        echecPageName.push(page.name)
                    }
                });

                await Promise.all(promises);
                console.log("echecPageName",echecPageName)
                if (echecPageName.length) {
                    console.log("echecPageName2")
                    this.notify({
                        title: `Echec lors de la creation du tableau`,
                        text:`Impossible de créer le tableau "${this.inputModel.valueNewBoard}" pour ${echecPageName.length == 1 ? 'la page' : 'les pages :'} ${echecPageName.join(', ')}`,
                        color:'success',
                        time: 4000,
                        id: new Date().getTime()
                    })    
                }
               

    
            },

            selectBoard(idBoard) {

                if ((idBoard == 'unselected' || idBoard == 'none') && this.formDataPinterest.boardSelectedByPage[this.inputModel.pageIdSelectBoardSelect]) {
                    this.$delete(this.formDataPinterest.boardSelectedByPage, this.inputModel.pageIdSelectBoardSelect);
                }else{
                    this.$set(this.formDataPinterest.boardSelectedByPage, this.inputModel.pageIdSelectBoardSelect, idBoard)
                }
                this.$emit('setFormDataNetwork', 'pinterest', this.formDataPinterest)



                //this.$set(this.inputModel.boardSelectedPerPage, this.inputModel.pageIdSelectBoardSelect, idBoard)
            }
        },

        computed: {
            allPages() {
                return this.$store.getters['selectPage/selectPageAllPages'];
            },
            pagesSelected() {
                return this.$store.getters['selectPage/selectPagePageSelected'];
            },
            pagePinterestSelectedForSelect() {
               return Object.fromEntries(this.$store.getters['selectPage/selectPagePageSelected'].filter(p => p.network == 'pinterest').map(p => [p.id,p.name]))
            }
        },

        watch: {
            pagesSelected(newValue) {
                this.pagesPinterestSelected  = this.pagesSelected.filter(p => p.network == 'pinterest')
            },
            pagesPinterestSelected() {
                this.detectPageIdSelectBoardSelect()
                this.detectPageIdSelectBoardCreate()

                this.pagesPinterestSelected.forEach(async (page) => {
                    await this.getBoards(page.id, page)
                });
            },

            ['formData.formDataNetwork.pinterest']() {
                if (this.formData.formDataNetwork.pinterest) this.formDataPinterest = this.formData.formDataNetwork.pinterest
            },

            'formData.urlsTextContentHistory'(newValue) {
                this.verifUrlSelected()
            },
        },


        beforeDestroy () {
        }
       
   }
</script>

